export const SERVICE_CHARGE_PERCENTAGE = 0.18

export const SMS_CHARACTER_LIMIT = 1600 // this is given by the GSM standard
